import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "w-64 px-2 overflow-y-auto scroll-box h-screen code-box",
  style: {"height":"100%"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"color":"#f50"} }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "flex mb-3 items-center" }
const _hoisted_6 = { key: 0 }

import { computed, defineComponent, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
import request from "../../common/request";
import { getRealFactoryIdListById, transformDate, transformDate2, getGroupListByFactory, getRealFactoryIdList } from "../../common/tools";
import { v4 as uuidv4 } from "uuid";
import { message } from "ant-design-vue";





export default /*@__PURE__*/_defineComponent({
  __name: 'On',
  setup(__props) {

let currentMachine = ref<any>();
const selectTree = (key: any, val: any) => {
  if (val.node.type == "machine") {
    currentMachine.value = val.node;
    search();
  }
};

let filterKeyWord = ref<any>();
let treeData = ref<any>();

const onExpand = (keys: string[]) => {
  expandedKeys.value = keys;
  autoExpandParent.value = false;
};
const expandedKeys = ref<(string | number)[]>([]);
const autoExpandParent = ref<boolean>(true);

watch(filterKeyWord, () => {
  expandedKeys.value = [];
  sonKey(treeData.value, "");
  autoExpandParent.value = true;
});
const sonKey = (item: any) => {
  item.forEach((element: any) => {
    if (element.title.indexOf(filterKeyWord.value) > -1) {
      // expandedKeys.value.push(key);
      expandedKeys.value.push(element.key);
    }
    if (element.children && element.children.length) {
      sonKey(element.children, element.key);
    }
  });
};
const getParentKey = (
  key: string | number,
  tree: any
): string | number | undefined => {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (
        node.children.some((item: { key: string | number }) => item.key === key)
      ) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
};


let factoryList = ref<any>();
  let allFactory:any = ref([])
const loadFactory = (requestId: any) => {
  const config = {
    params: {},
    headers: {
      requestId: requestId,
    },
  };
  request.get("/api/factories", config).then((res: any) => {
    if (res) {
      allFactory.value = res.data;
      // 2级工厂
      var list = res.data.map((t: any) => ({
        key: t._id,
        title: t.factoryName,
        value: t._id,
        label: t.factoryName,
        parentId: t.parentId,
        id: t._id,
        type: "factory",
        children: t.groups.map((group: any) => ({
          type: "group",
          value: group.sonID,
          label: group.name,
          title: group.name,
          key: group.sonID,
        })),
      }));
      let factory:any = [];
      let parentFs = list.filter((p:any) => !p.parentId)
      parentFs.map((d:any) => {
        let sonFactory = list.filter((p:any) => p.parentId === d.id)
        if(sonFactory && sonFactory.length) {
          d.children = sonFactory
        }
        factory.push(d);
      })

      factoryList.value = factory;
      loadMachine(requestId);
    }
  });
};
const loadMachine = async(requestId: any) => {
  let factoryIds = allFactory.value.map((p:any) => p._id)
  let res = await request.post("/api/machines/all", {factoryIds})
  factoryList.value.forEach((element: any) => {
    if (res) {
        element.children.forEach((sonFact: any) => {
          if (sonFact.type == "factory" && sonFact.children) {
            sonFact.children.forEach((groupFact: any) => {
              if (groupFact.type == "group") {
                groupFact.children = res.data
                  .filter((t: any) => t.groupId == groupFact.value)
                  .map((t: any) => ({
                    type: "machine",
                    ...t,
                    value: t.id,
                    label: t.machineName,
                    title: t.machineName,
                    key: t.id,
                  }));
              }
            });
          } else if (sonFact.type == "group") {
            sonFact.children = res.data
              .filter((t: any) => t.groupId == sonFact.value)
              .map((t: any) => ({
                type: "machine",
                ...t,
                value: t.id,
                label: t.machineName,
                title: t.machineName,
                key: t.id,
              }));
          }
        });
      }
  });
  setTimeout(() => {
    treeData.value = factoryList.value;
  }, 100);
};

const columns = [
    {
        title: '开关机测点',
        dataIndex: 'sensorId',
    },
    {
        title: '数据类型',
        dataIndex: 'dataType',
    },
    {
        title: '间隔',
        dataIndex: 'interval',
    },
    {
        title: '开关机阈值',
        dataIndex: 'threshold',
    },
]

let data:any = ref([])
let sensorList:any = ref([])
let dataTypeList:any = ref([])

onMounted(() => {
    init()
})

const init = () => {
    getDatatype()
    var requestId = uuidv4();
    loadFactory(requestId);
}

const getDatatype = () => {
    const config = {
        headers: {
            requestId: uuidv4(),
        },
    };
    request.get("/api/sensors/datatype", config).then((res: any) => {
        if (res) {
            let list:any = res.data.map((t: any) => ({
                value: t.name,
                label: t.name,
            }));

            dataTypeList.value = list.concat([{label: '原始波形', value: '原始波形'}])
        }
    });
};
const noSave = ref(false)
const search = async() => {
    if(!currentMachine.value) return
    sensorList.value = []

    const config = {
        params: {
            machineId: currentMachine.value.id
        },
        headers: {
            requestId: uuidv4(),
        },
    };
    let resultSensor = await request.get('/api/sensors', config)
    if(resultSensor?.data?.length > 0) {
      sensorList.value = resultSensor.data
    }

    let result = await request.get('/api/machine-online-config/info', config)
    if(result && result.data) {
      noSave.value = false
        data.value = [
            result.data
        ]
    } else {
      noSave.value = true
        data.value = [
            {
                machineId: currentMachine.value.id,
                sensorId: '',
                dataType: '',
                interval: null,
            }
        ]
    }
}

const submit = async() => {
    let result = data.value[0]._id ? await request.put('/api/machine-online-config', data.value[0]) : await request.post('/api/machine-online-config', data.value[0])
    if(result && result.data) {
        message.success('操作成功!')
        search()
    } else {
        message.warning('操作失败，请联系管理员')
    }
}



const getRowClassName = (record:any, index:any) => {
    // 根据索引设置不同的类名
    return index % 2 === 0 ? 'odd-row' : 'even-row';
}

return (_ctx: any,_cache: any) => {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_layout_content, { style: {"padding":"0 20px","height":"100%"} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, {
          type: "flex",
          style: {"height":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              span: 5,
              order: 1,
              style: {"height":"100%"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_a_input_search, {
                    value: _unref(filterKeyWord),
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(filterKeyWord) ? (filterKeyWord).value = $event : filterKeyWord = $event)),
                    style: {"margin-bottom":"8px"},
                    placeholder: "输入区域或设备名称筛选"
                  }, null, 8, ["value"]),
                  _createVNode(_component_a_tree, {
                    class: "draggable-tree",
                    draggable: "",
                    "block-node": "",
                    autoExpandParent: autoExpandParent.value,
                    "expanded-keys": expandedKeys.value,
                    "tree-data": _unref(treeData),
                    onExpand: onExpand,
                    onSelect: selectTree
                  }, {
                    title: _withCtx(({ title }) => [
                      (title.indexOf(_unref(filterKeyWord)) > -1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                            _createTextVNode(_toDisplayString(title.substr(0, title.indexOf(_unref(filterKeyWord)))) + " ", 1),
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(filterKeyWord)), 1),
                            _createTextVNode(" " + _toDisplayString(title.substr(
                            title.indexOf(_unref(filterKeyWord)) + _unref(filterKeyWord).length
                            )), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(title), 1))
                    ]),
                    _: 1
                  }, 8, ["autoExpandParent", "expanded-keys", "tree-data"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              span: 19,
              order: 2,
              style: {"padding-bottom":"20px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  (_unref(currentMachine))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createTextVNode(_toDisplayString(_unref(currentMachine).machineName) + " ", 1),
                        (noSave.value)
                          ? (_openBlock(), _createBlock(_component_a_tag, {
                              key: 0,
                              color: "#f50"
                            }, {
                              default: _withCtx(() => _cache[1] || (_cache[1] = [
                                _createTextVNode("未保存")
                              ])),
                              _: 1,
                              __: [1]
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: submit
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("保存")
                    ])),
                    _: 1,
                    __: [2]
                  })
                ]),
                (_unref(currentMachine))
                  ? (_openBlock(), _createBlock(_component_a_table, {
                      key: 0,
                      style: {"width":"100%"},
                      size: "small",
                      "row-class-name": getRowClassName,
                      columns: columns,
                      "data-source": _unref(data),
                      pagination: false
                    }, {
                      bodyCell: _withCtx(({ column, text, record }) => [
                        (column.dataIndex === 'sensorId')
                          ? (_openBlock(), _createBlock(_component_a_select, {
                              key: 0,
                              value: record.sensorId,
                              "onUpdate:value": ($event: any) => ((record.sensorId) = $event),
                              style: {"min-width":"200px"},
                              placeholder: "请选择测点",
                              allowClear: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sensorList), (item, index) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: index,
                                    value: item.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.sensorPlace), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["value", "onUpdate:value"]))
                          : _createCommentVNode("", true),
                        (column.dataIndex === 'dataType')
                          ? (_openBlock(), _createBlock(_component_a_select, {
                              key: 1,
                              value: record.dataType,
                              "onUpdate:value": ($event: any) => ((record.dataType) = $event),
                              style: {"min-width":"200px"},
                              placeholder: "请选择数据类型",
                              allowClear: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataTypeList), (item, index) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: index,
                                    value: item.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["value", "onUpdate:value"]))
                          : _createCommentVNode("", true),
                        (column.dataIndex === 'interval')
                          ? (_openBlock(), _createBlock(_component_a_input_number, {
                              key: 2,
                              style: {"min-width":"100px"},
                              value: record.interval,
                              "onUpdate:value": ($event: any) => ((record.interval) = $event),
                              controls: false
                            }, null, 8, ["value", "onUpdate:value"]))
                          : _createCommentVNode("", true),
                        (column.dataIndex === 'threshold')
                          ? (_openBlock(), _createBlock(_component_a_input_number, {
                              key: 3,
                              style: {"min-width":"100px"},
                              value: record.threshold,
                              "onUpdate:value": ($event: any) => ((record.threshold) = $event),
                              controls: false
                            }, null, 8, ["value", "onUpdate:value"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["data-source"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})